export { default as Shortcut } from './component';
export type { Props as ShortcutProps, ShortcutDescription } from './component';
